export const PAGINATION_LIMIT_MIN = 25;
export const PAGINATION_LIMIT_MID = 50;
export const PAGINATION_LIMIT_MAX = 100;

export const INITIAL_LIMIT = 300;

export const INFINITE_SCROLL_LOAD_THRESHOLD = 90;
